import { cloneDeep, forEach } from 'lodash';
import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { RdSAPSuggestedImprovementV0 } from '../../../../../models/rdsap/rdSAPSuggestedImprovementV0';
import { UtilsService } from 'src/rdsap/services/utils/utils.service';
import { RdSAPGeneralDetailUIDTOV0 } from 'src/rdsap-api';
interface ExtendedRdSAPSuggestedImprovement extends RdSAPSuggestedImprovementV0 {
  selected: boolean;
  reasonNotSelected?: string;
}


// Define the type for SapImprovementMeasureCodeUIDTOV0
export type SapImprovementMeasureCodeUIDTOV0 =
  | 'A' | 'A2' | 'A3' | 'B' | 'B4' | 'C' | 'D' | 'E' | 'F' | 'G'
  | 'H' | 'I' | 'J' | 'J2' | 'K' | 'L' | 'L2' | 'M' | 'N' | 'O' | 'O3'
  | 'P' | 'Q' | 'Q2' | 'R' | 'S' | 'T' | 'T2' | 'U' | 'V' | 'V2' | 'W'
  | 'W1' | 'W2' | 'X' | 'Y' | 'Y2' | 'Z1' | 'Z2' | 'Z3' | 'NR';


@Component({
  selector: 'app-rdsap-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss']
})
export class RecommendationsComponent implements OnInit {
  private _eeRecommendations: ExtendedRdSAPSuggestedImprovement[] = [];
  @Input() description: any[] = [];


  eeGeneralDetails: RdSAPGeneralDetailUIDTOV0 = {
    address: undefined
  };
 

  constructor(private cd: ChangeDetectorRef, private utilsService: UtilsService) {}

  @Output() deselectedItemsData = new EventEmitter<any>();



  @Input()
  set eeRecommendations(value: ExtendedRdSAPSuggestedImprovement[]) {
    if (value) {
      this._eeRecommendations = cloneDeep(value).map(rec => ({ ...rec, selected: true }));
      this.setImprovementDescription();
    }
  }

  get eeRecommendations(): ExtendedRdSAPSuggestedImprovement[] {
    return this._eeRecommendations;
  }

  ngOnInit() {
    this.eeGeneralDetails = {
      deselectedImprovementMeasures: [],
      ...this.eeGeneralDetails
    };
    
  }

  filterLookupCodes(filter) {
    return this.utilsService.filterLookupCodes(filter);
  }

  setImprovementDescription() {
    const descriptions = new Set();
    forEach(this._eeRecommendations, (element) => {
      const lookupcodes = this.filterLookupCodes('Recommendation');
      forEach(lookupcodes, (elem) => {
        if (elem.lookupValue === element.improvementType) {
          descriptions.add(elem.lookUpItem);
        }
      });
    });
    this.description = Array.from(descriptions);
  }

  updateRecommendationSelection(index: number, isChecked: boolean): void {
    const recommendation = this._eeRecommendations[index];
    recommendation.selected = isChecked;
  
    this.eeGeneralDetails.deselectedImprovementMeasures = this._eeRecommendations
      .filter(rec => !rec.selected)
      .map(rec => rec.improvementType as SapImprovementMeasureCodeUIDTOV0);
  
    this.deselectedItemsData.emit(this.eeGeneralDetails);
    console.log('Deselected Improvements:', this.eeGeneralDetails.deselectedImprovementMeasures);
  }
}

